import * as departments from '@/services/departments.js'
import orderBy from 'lodash/orderBy'

export default {
  async getDepartments({ state, commit }, filter) {
    const data = await departments.getDepartments({ filter })
    commit('SET_OBJECT', { name: 'departments', data: orderBy(data, 'name'), state })
  },
  async getUnitDepartmentReviews({ state, commit }, unitId) {
    const data = await departments.getUnitDepartmentReviews(unitId)
    return data
  },
}
